const configService = {
  apiUrl: process.env.VUE_APP_URL_API_PHP + "/api",
  apiNodeUrl: process.env.VUE_APP_URLAPI,
  apiJitsi: process.env.VUE_APP_MEET,
  apiSocket: process.env.VUE_APP_SOCKET
};

export default configService;
